<template>
  <div class="test-wrapper">
    <p class="step">Результат</p>
    <h2 class="step_name">Ваш уровень {{level}}</h2>

    <div
      class="text"
    >
    <p 
      v-if="textKids"
    >
    {{ textKids }}</p>
    Отлично. Тест пройден. Осталось записаться на устное тестирование в одну из наших школ и определиться с программой обучения.</div>
    <div class="progressbar-wrapper">
      <div id="container">
        <vue-easy-pie-chart
          :percent="dataPer[levelLet]"
          :bar-color="'#92d36e'"
          :track-color="'rgb(255, 115, 115)'"
          :scale-color="''"
          :line-width="10"
          :animate="true"
        >
          <div class="lvl">{{levelLet}}</div>
        </vue-easy-pie-chart>
      </div>
      <div class="text_lvl">{{level}}</div>
      <div class="questions_num">
        <div class="num_correct">{{correctAnswer}}</div>
        <div class="num_wrong">{{errorAnswer}}</div>
        <div style="clear: both;"></div>
      </div>
    </div>

    <div class="info-blocks">
      <div id="info-block1" class="block more">
        <div class="title">Подробные результаты теста</div>
        <div class="q-block_wrapper">
          <div
            v-for="(quest, index, id) in questions"
            :key="id"
            class="q-block"
            :class="[(isCorrect(quest.correct_answer, quest.answer)) ? 'correctly' : 'uncorrectly']"
          >{{index + 1}}</div>
        </div>
      </div>
      <div id="info-block2" class="block review active-block">
        <div class="title">Нам важно Ваше мнение!</div>
        <p>1) Данный уровень соответствует вашим ожиданиям?</p>
        <div class="buttons">
          <label class="buttons__radio-label" for="level-yes">
            <input id="level-yes" type="radio" name="level" v-model="itsYourLevel" value="Да">
            <div class="yes">Да</div>
          </label>
          <label class="buttons__radio-label" for="level-no">
            <input id="level-no" type="radio" name="level" v-model="itsYourLevel" value="Нет">
            <div class="no">Нет</div>
          </label>
        </div>
        <p>2) Тест был удобен?</p>
        <div class="buttons">
          <label class="buttons__radio-label" for="test-yes">
            <input id="test-yes" type="radio" name="test" v-model="useFullTest" value="Да">
            <div class="yes">Да</div>
          </label>

          <label class="buttons__radio-label" for="test-no">
            <input id="test-no" type="radio" name="test" v-model="useFullTest" value="Нет">
            <div class="no">Нет</div>
          </label>
        </div>
      </div>
      <div id="info-block3" class="block share">
        <div class="title">Поделиться результатом в соцсетях</div>
        <div class="socials">
          <social-sharing
            url="/quiz"
            :title="'Мои результаты теста по иностранному языку уровень ' + level +' '+ correctAnswer + ' верно ' + errorAnswer + ' не верно'"
            :description="'ВКС школа иностранных языков' + correctAnswer + ' верно ' + errorAnswer + ' не верно'"
            :quote="'Тесты уровень ' + level +' '+ correctAnswer + ' верно ' + errorAnswer + ' не верно'"
            hashtags="Тесты,английский,немецкий"
            twitter-user="vuejs"
            :networks="overriddenNetworks"
            inline-template
          >
            <div class="socials__network">
              <network network="vk">
                <div class="item vk"></div>
              </network>
              <network network="tiktok">
                <div class="item tiktok"></div>
              </network>
              <network network="odnoklassniki">
                <div class="item ok"></div>
              </network>
              <network network="telegram">
                <div class="item telegram"></div>
              </network>
            </div>
          </social-sharing>

          <a rel="nofollow" target="_blank" href="http://www.youtube.com/user/BKCIH">
            <div class="item ytube"></div>
          </a>
        </div>
      </div>
    </div>
    <div class="info-buttons">
      <div data-id="#info-block1" class="button more">
        <p>Подробнее о тесте</p>
      </div>
      <div data-id="#info-block2" class="button review active">
        <p>Отзыв</p>
      </div>
      <div data-id="#info-block3" class="button share">
        <p>Подеиться результатом</p>
      </div>
    </div>

    <div
      class="text"
    >Поздравляем с прохождением теста. Совершите качественный скачок в образовании вместе с нами.
      <br>
      <br>
    </div>
    <form id="tests" method="post">
      <div class="button-wrapper">
        <div class="test-next">
          <a href="/#language">
            <div class="form-submit">
              <input type="text" id="finish_test" value="Подробнее о курсах">
            </div>
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import SocialSharing from "vue-social-sharing";
import VueEasyPieChart from "vue-easy-pie-chart";
import "vue-easy-pie-chart/dist/vue-easy-pie-chart.css";

export default {
  name: "result",
  components: { SocialSharing, VueEasyPieChart },
  props: {
    category: {
      type: String
    },
    testKey: {
      type: String
    },
    questions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    level: {
      type: String
    },
    levelId: {
      type: String
    }
  },
  data() {
    return {
      sended: false,
      correctAnswer: 0,
      errorAnswer: 0,
      levelLet: "",
      selected: "",
      schollInfo: "",
      toPage: {
        английский: "/learn_english/",
        немецкий: "/languages/german/",
        французский: "/languages/french/",
        итальянский: "/languages/italiano/",
        испанский: "/languages/spanish/",
        "для детей": "/child/"
      },
      dataPer: {
        A1: 15,
        B1: 45,
        B2: 60,
        C1: 75
      },
      itsYourLevel: false,
      useFullTest: false,
      overriddenNetworks: {
        instagram: {
          sharer: "https://www.instagram.com",
          type: "popup"
        },
        tiktok: {
          sharer: "https://vm.tiktok.com/ZSde9MrRE/",
          type: "popup"
        },
        telegram: {
          sharer: "https://t.me/bkc_ih_moscow",
          type: "popup"
        }
      },
      textKids: "",
    };
  },
  mounted: function() {
    $("body").off("click", "#info-block2 .yes");
    $(document.body).off("click", "#info-block2 .no");
    this.scrollToTest();
    this.testKey = this.testKey.toLowerCase().trim();
    let category = this.category.toLowerCase().trim();
    if (category === "для детей") {
      this.testKey = category;
    }

    let level = this.level.split("-");
    this.level = level[level.length - 1];
    this.levelLet = level[0].trim();
    this.proccesResult();
    this.selectTextKids(this.levelId);
  },
  computed: {},
  methods: {
    scrollToTest: function() {
      $("html, body").animate(
        { scrollTop: $(".container-test").offset().top },
        0
      ); // анимируем скроолинг к элементу scroll_el
    },
    sendUsability: function() {
      let url = "/quiz/api/test.php?send_mail";

      $.ajax({
        url: url,
        type: "POST",
        data: {
          itsyourlevel: this.itsYourLevel,
          usefull: this.useFullTest
        },
        success: data => {
          alert("Результаты отправлены");
        },
        error: error => {
          alert("error");
        }
      });
    },
    isCorrect: function(correctMas, answer) {
      let correct = false;
      for (let el of correctMas) {
        if (el.toLowerCase().trim() === answer.toLowerCase().trim()) {
          correct = true;
          break;
        }
      }
      return correct;
    },
    proccesResult: function() {
      for (let i = 0, max = this.questions.length; i < max; i++) {
        if (
          this.isCorrect(
            this.questions[i]["correct_answer"],
            this.questions[i]["answer"]
          )
        ) {
          this.correctAnswer += 1;
        } else {
          this.errorAnswer += 1;
        }
      }
    },
    selectTextKids: function(lvlId) {
      switch (lvlId) {
        case "379490":
          this.textKids = 'На этом уровне мы уже знаете правила чтения английского языка и узнаёте базовую лексику: цвета, цифры, животные, еда, местоимения, фрукты и овощи, письменные принадлежности, предметы мебели, профессии, страны и города, школьные предметы. Вам знакомы некоторые фразы и грамматические темы: глагол to be – am/is/are, There is/There are, have got/has got, Present Simple, Present Continuous, притяжательные прилагательные - my/your/his/her/its/our/their, вопросительные слова - what/where/when/how/how often/why/who.';
          break;
        case "379792":
          this.textKids = 'На этом уровне вы уже уверенно читаете на английском языке, можете представиться, рассказать о себе, своей семье, вкусах и интересах. Вы читаете небольшие тексты и понимаете на слух речь на знакомые вам темы: семья, еда, школьные предметы, здоровье, профессии, места в городе, музыка, развлечения, здоровье, болезни, растения, география, творчество, технологии, путешествия и многие другие. Вам знакомы грамматические темы: Present Simple, Present Continuous, Past Simple, Past Continuous, can, should, must, comparative and superlative adjectives.';
          break;
        case "379794": 
          this.textKids = 'На этом уровне вы уверенно читаете тексты средней сложности на английском языке, можете представиться, рассказать о себе, своей семье, вкусах и интересах, поделиться историями из жизни, спросить и дать совет. Вы знаете лексику на темы: школьные предметы, здоровье, профессии, места в городе, музыка, развлечения, здоровье, болезни, история и география, творчество и искусство, знаменитости, технологии, путешествия и многие другие. Вам знакомы грамматические темы: Present Simple, Present Continuous, Past Simple, Past Continuous, modal verbs, articles.';
          break;
        case "379796": 
          this.textKids = 'На этом уровне вы уверенно читаете длинные тексты на английском языке, можете рассказать о своей жизни, высказать и аргументировать свою точку зрения, а также написать электронное письмо, небольшое эссе или статью, сочинить историю, подготовить презентацию проекта и многое другое. Вы знаете лексику на темы: транспорт, наука, здоровье, профессии, места в городе, развлечения, здоровье, болезни, история и география, творчество и искусство, технологии, путешествия и многие другие. Вам знакомы грамматические темы: Present Perfect, be going to, Past Continuous, modal verbs, articles, conditionals.';
          break;
        case "1375689": 
          this.textKids = 'Поздравляем! У вас уровень Gateway A1+. Вы уже знаете правила чтения и базовую лексику, например, цвета, числа, дни недели, члены семьи. На этом уровне вы можете рассказать о себе, своих увлечениях и семье. Вам знакомы такие грамматические темы, как to be – am/is/are, Present Simple, Present Continuous, like/don’t like doing, have got/has got, there is/there are, а также правила построения утвердительных, отрицательных и вопросительных предложений.';
          break;
        case "1375688": 
          this.textKids = 'Поздравляем! У вас уровень Gateway A2. Вы уже уверенно читаете и знакомы с лексикой на базовые темы, например, животные, погода и времена года, еда и напитки, привычки, школьные предметы, развлечения. На этом уровне вы можете рассказать о своих любимых вещах, написать небольшой текст о себе, правильно сформулировать свои мысли и поддержать диалог на несложные темы. Вам знакомы такие грамматические конструкции, как Present Simple, Present Continuous, like/hate/don’t mind doing, have got/has got, can/can’t, should, must, have to, be going to/will/Present Continuous for plans.';
          break;
        case "1375687": 
          this.textKids = 'Поздравляем! У вас уровень Gateway B1. Вы уверенно читаете тексты средней сложности, понимаете на слух диалоги, отрывки из радиопередач и интервью. Вы владеете лексикой на такие темы, как природные катаклизмы, географические объекты, продукты, материалы, наука и техника, развлечения. На этом уровне вы можете поделиться своими воспоминаниями, написать небольшое эссе, правильно аргументировать своё мнение и поддержать диалог на большинство тем. Вам знакомы такие грамматические конструкции, как Present Perfect Simple, Present Perfect Continuous,  should, must, have to, ought to, Past Perfect, Conditional sentences.';
          break;
        case "1375686": 
          this.textKids = 'Поздравляем! У вас уровень Gateway B1+. Вы уверенно читаете тексты средней сложности, понимаете на слух диалоги, отрывки из радиопередач и интервью. Вы владеете лексикой на такие темы, как природные катаклизмы, географические объекты, продукты, материалы, наука и техника, развлечения. На этом уровне вы можете поделиться своими воспоминаниями, написать небольшое эссе, правильно аргументировать своё мнение и поддержать диалог на большинство тем. Вам знакомы такие грамматические конструкции, как Present Perfect Simple, Present Perfect Continuous,  should, must, have to, ought to, Past Perfect, Conditional sentences.';
          break;
        case "1375685": 
          this.textKids = 'Поздравляем! У вас уровень Gateway B2. Вы уверенно читаете тексты различной сложности, понимаете на слух диалоги, радиопередачи и интервью. Вы владеете лексикой на разнообразные: социальные проблемы, работа и карьера, финансы, экология, наука и техника, литература и искусство. На этом уровне вы можете рассказать о самых запоминающихся событиях в вашей жизни, написать эссе, статью и историю, правильно аргументировать своё мнение и поддержать диалог на большинство тем. Вам знакомы такие грамматические конструкции, как Present Perfect Simple, Present Perfect Continuous, modal verbs, Past Perfect, Past Perfect Continuous, Future Continuous, Perfect, Conditional sentences 1, 2, 3.';
          break;
        case "1375684": 
          this.textKids = 'Поздравляем! У вас уровень Gateway B2+. Вы уверенно читаете тексты различной сложности, понимаете на слух диалоги, радиопередачи и интервью. Вы владеете лексикой на разнообразные: социальные проблемы, работа и карьера, финансы, экология, наука и техника, литература и искусство. На этом уровне вы можете рассказать о самых запоминающихся событиях в вашей жизни, написать эссе, статью и историю, правильно аргументировать своё мнение и поддержать диалог на большинство тем. Вам знакомы такие грамматические конструкции, как Present Perfect Simple, Present Perfect Continuous, modal verbs, Past Perfect, Past Perfect Continuous, Future Continuous, Perfect, Conditional sentences 1, 2, 3.';
          break;
        case "1375683": 
          this.textKids = 'Поздравляем! У вас уровень Gateway C1. Вы уверенно читаете тексты повышенной сложности на любые темы, понимаете на слух естественную речь, фильмы в оригинале, радиопередачи и интервью. Вы владеете лексикой на разнообразные темы: социальные проблемы, общество, история, работа и карьера, финансы, экология, наука и техника, литература и искусство. На этом уровне вы можете рассказать о самых запоминающихся событиях в вашей жизни, написать эссе, статью и историю, правильно аргументировать своё мнение и поддержать диалог на любые темы. Вам знакомы такие грамматические конструкции, как Present Perfect Simple, Present Perfect Continuous, modal verbs, Past Perfect, Past Perfect Continuous, Future Continuous, Perfect, Conditional sentences 1, 2, 3 and mixed.';
          break;
      }
    }
  },
  watch: {
    itsYourLevel: function() {
      if (this.sended !== true && this.useFullTest !== false) {
        this.sended = true;
        this.sendUsability();
      }
    },
    useFullTest: function() {
      if (this.sended !== true && this.itsYourLevel !== false) {
        this.sended = true;
        this.sendUsability();
      }
    },
    selected: function() {
      axios
        .post("/quiz/api/test.php?save_result&school=" + this.selected.id)
        .then(response => {})
        .catch(error => {
          alert("Ошибка отправки школы");
        });
    }
  }
};
</script>

<style lang="sass">
    .buttons

        &__radio-label
            input
                display: none

                &:checked ~ div
                    background: #00bcc6
                    color: white

        .socials
            &__network
                display: inline-block
                div
                    cursor: pointer


</style>



// WEBPACK FOOTER //
// src/components/Result.vue